import { createEvent, createStore } from "effector";

export type SafeAreaInsets = {
  top: number;
  right: number;
  bottom: number;
  left: number;
};

export const ZERO_SAFE_AREA: SafeAreaInsets = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
};

export const updateSafeAreaInsets = createEvent<SafeAreaInsets>();

export const $safeAreaInsets = createStore<SafeAreaInsets>(ZERO_SAFE_AREA).on(
  updateSafeAreaInsets,
  (_, next) => next
);
